import PosthogService from '~/services/posthog/PosthogService';
import type { TProCategory } from './types';

export interface IProfessionalSelectedPayload {
  professionalId: string;
  proCategory: TProCategory;
}

/**
 * Fires when the user selects a professional in the Invite popup
 * Event: dental_portal:invite:professional_selected
 */
export function fireProfessionalSelected(payload: IProfessionalSelectedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:professional_selected', {
    professional_id: payload.professionalId,
    pro_category: payload.proCategory,
  });
}
